import React from 'react';
import {
    Flex,
    FlexProps,
    Grid,
    Heading,
} from '@chakra-ui/react';
import { Image } from 'shared';
import { RichText } from './RichText';

type BlockHeaderProps = {
    title: string,
    description?: any,
    imageSrc: string
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const BlockHeader: React.FC<BlockHeaderProps> = ({
    title,
    description,
    imageSrc,
    ...props
}) => (
    <Flex
        flexDirection="column"
        position="relative"
        background="#000000"
        {...props}
    >
        <Flex
            flexDirection="column"
            position="relative"
            minHeight="40vh"
            background="linear-gradient(0deg, rgba(0,0,0,1) 20%, rgba(255,255,255,0) 100%)"
        >
            <Image
                src={imageSrc}
                position="absolute"
                width="100%"
                height="100%"
                opacity="0.5"
            />
            <Flex
                flexDirection="column"
                gap="1rem"
                padding="6rem 2rem 2rem 2rem"
                zIndex={1}
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                height="100%"
                margin="auto auto 0 auto"
            >
                <Grid
                    height="fit-content"
                    margin="auto auto 0 0"
                    width="70%"
                    gap="1rem"
                >
                    <Heading
                        colorScheme="variant"
                        size="lg"
                    >
                        {title}
                    </Heading>
                    <RichText
                        content={description}
                        colorScheme="variant"
                        fontSize="2rem"
                        lineHeight={1}
                        lineClamp={10}
                    />
                </Grid>
            </Flex>
        </Flex>
    </Flex>
);
